module.exports = __webpack_public_path__ + "assets/images/mascotte-805b025ef53792a28225cc3e29bfd2d1.png";